import axios from 'axios'
import router from '@/router';
import { Message } from 'element-ui'
import { getToken } from "@/utils/token";
import store from '@/store';
// 请求拦截器的封装
// const baseURL = import.meta.env.VITE_MODE === 'dev' ? '' : import.meta.env.VUE_APP_BASE_URL;
// instance 实例 对象
const instance = axios.create({
    baseURL: '',
    timeout: 5000
})


//请求拦截器
instance.interceptors.request.use(config => {
    // 记录本此请求的相关信息
    let token = getToken()
    if (token) {
        if (!config.headers) {
            config.headers = {};
        }
        config.headers.Authorization = 'application/json'
        config.headers['token'] = token;
    }
    // 设置Accept-Language为中文
    config.headers['Accept-Language'] = 'zh_CN';
    return config
}, err => {
    console.error(err);
    Message({
        message: err.message,
        type: 'error',
        duration: 5 * 1000
    })
    return Promise.reject(err)
})


//响应拦截器
instance.interceptors.response.use(response => {
    const res = response.data;
    if (!res.code) {
        return res
    }
    if (res.message == '用户未登录' && res.code == -401) {
        router.push('/')
        // 清除本地存储
        localStorage.clear()

        store.commit("HANLE_VISIBLE_DIALOG", true);
    }
    if (res.code !== 200) {
        Message({
            message: res.message || 'Error',
            type: 'error',
            duration: 3 * 1000
        });
        return res
        // return Promise.reject(new Error(res.message || 'Error'));
    } else {
        // 返回实际数据部分
        return res;
    }
}, err => {
    console.error('err', err);
    Message({
        message: err.message,
        type: 'error',
        duration: 5 * 1000
    });
    return Promise.reject(err)
})


export default instance